import React, { memo } from 'react';
import { Book as BookIcon } from 'lucide-react';
// Memoize the Header component to prevent unnecessary re-renders
const Header = memo(() => {
  // Track click event
  const handlePurchaseClick = () => {
    if (window.fbq) window.fbq('track', 'AddToCart', {
      content_name: '7 Cenas Latinas en 30 Minutos',
      content_type: 'product',
      value: 7.0,
      currency: 'USD'
    });
  };
  return <div className="w-full bg-custom-brown text-white py-3 px-4 sticky top-0 z-50" data-id="element-156">
      <div className="container mx-auto flex items-center justify-between" data-id="element-157">
        <div className="flex items-center" data-id="element-158">
          <BookIcon size={20} className="mr-2" data-id="element-159" />
          <span className="text-lg font-medium" data-id="element-160">
            7 cenas latinas en 30 minutos
          </span>
        </div>
        <a href="https://pay.hotmart.com/W101891326K?checkoutMode=10" className="bg-white text-custom-brown hover:bg-custom-brown hover:text-white font-bold py-1 px-4 rounded-full text-sm transition duration-300" onClick={handlePurchaseClick} data-id="element-161">
          Comprar $7.00
        </a>
      </div>
    </div>;
});
export default Header;